'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromizeMailShare = function (_React$Component) {
    _inherits(PromizeMailShare, _React$Component);

    function PromizeMailShare(props) {
        _classCallCheck(this, PromizeMailShare);

        var _this = _possibleConstructorReturn(this, (PromizeMailShare.__proto__ || Object.getPrototypeOf(PromizeMailShare)).call(this, props));

        _this.handleUserInput = function (e) {
            var fields = _this.state.fields;
            fields[e.target.name] = e.target.value;
            _this.setState({ fields: fields });
        };

        _this.closeMailPopup = function (e) {
            _this.props.cart.setState({ showEmailPopUp: false });
        };

        _this.handleSubmit = async function (e) {
            e.preventDefault();
            if (await _this.validateForm()) {
                _this.props.HomeComponent.setState({ 'pzPageLoader': true });
                var fields = {};
                fields["sendermail"] = "";
                fields["receivermail"] = "";
                fields["message"] = "";
                fields["mailsent"] = "";

                var imagedata = {};

                var selectedObject = _this.props.HomeComponent.pzGetSelectedValuesForCart(_this.props.pzCanvasObject);
                var canvasDataUrl = await _this.props.HomeComponent.pzGetCombinedImage();
                var data = {
                    sendermail: _this.state.fields.sendermail,
                    receivermail: _this.state.fields.receivermail,
                    message: _this.state.fields.message,
                    sharedLink: _this.state.sharedLink,
                    selectedValues: {}
                };

                var currentThis = _this;
                var HomeComponentThis = _this.props;
                if (selectedObject) {
                    _this.props.HomeComponent.pzSaveCanvasImage(canvasDataUrl).then(function (saveCanveasImageresponse) {

                        var pzSelectedObjects = _extends({}, selectedObject.cartObject);
                        pzSelectedObjects['DESIGNED IMAGE'] = saveCanveasImageresponse ? HomeComponentThis.pzImgUrl + saveCanveasImageresponse : '';
                        console.log("selectedObject ", pzSelectedObjects);

                        data.selectedValues = _extends({}, pzSelectedObjects);
                        data['image'] = pzSelectedObjects['DESIGNED IMAGE'];
                        data['signatureText'] = (HomeComponentThis.pzDomainIds && HomeComponentThis.pzDomainIds[HomeComponentThis.pzCustomizer.product.domain_id]) ? HomeComponentThis.pzDomainIds[HomeComponentThis.pzCustomizer.product.domain_id]['signatureText'] : 'Wristbands.com';
                        $.ajax({
                            type: "POST",
                            crossDomain: true,
                            url: HomeComponentThis.pzApiUrl+'lanyardmailshare',
                            data: data,
                            success: function success(res) {
                                console.log(res);
                                HomeComponentThis.HomeComponent.setState({ 'pzPageLoader': false });
                                currentThis.setState({ fields: fields, mailStatus: 'ok' });
                                setTimeout(function () {
                                    currentThis.props.cart.setState({ showEmailPopUp: false });
                                }, 3000);
                            },
                            error: function error(err) {
                                HomeComponentThis.HomeComponent.setState({ 'pzPageLoader': false });
                                currentThis.setState({ fields: fields, mailStatus: 'err' });
                            }
                        });
                    });
                } else {
                    _this.props.HomeComponent.setState({ 'pzPageLoader': false });
                }
            }
        };

        _this.validateForm = async function () {
            var fields = _this.state.fields;
            var errors = {};
            var formIsValid = true;

            if (!fields["sendermail"]) {
                formIsValid = false;
                errors["sendermail"] = "*Please enter sender email-ID.";
            }

            if (typeof fields["sendermail"] !== "undefined") {
                //regular expression for email validation
                var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                if (!pattern.test(fields["sendermail"])) {
                    formIsValid = false;
                    errors["sendermail"] = "*Please enter valid sender email-ID.";
                }
            }

            if (!fields["receivermail"]) {
                formIsValid = false;
                errors["receivermail"] = "*Please enter receiver email-ID(s).";
            }
            if (typeof fields["receivermail"] !== "undefined" && fields["receivermail"].length > 200) {
                formIsValid = false;
                errors["receivermail"] = "*Please enter receiver email-ID(s) with maximum of 200 characters.";
            }

            //if (typeof fields["receivermail"] !== "undefined") {
            else {
                    //regular expression for email validation
                    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

                    var receiverEmail = fields["receivermail"].replace(/,+$/, '');
                    var receiverEmails = receiverEmail.split(",");

                    for (var inc = 0; inc < receiverEmails.length; inc++) {
                        if (!pattern.test(receiverEmails[inc].trim())) {
                            formIsValid = false;
                            errors["receivermail"] = "*Please enter valid receiver email-ID(s).";
                            break;
                        }
                    }
                }
            _this.setState({
                errors: errors
            });
            return formIsValid;
        };

        _this.state = {
            fields: {},
            sharedLink: props.editUrl,
            selectedValues: props.selectedValues,
            errors: {},
            mailStatus: ''
        };
        return _this;
    }

    _createClass(PromizeMailShare, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                React.Fragment,
                null,
                React.createElement(PZMailShare, _extends({ handleSubmit: this.handleSubmit, handleUserInput: this.handleUserInput }, this.props, this.state, { closeMailPopup: this.closeMailPopup }))
            );
        }
    }]);

    return PromizeMailShare;
}(React.Component);